import {request} from './request.js'
import AppConfig from '../../config/AppConfig.js'
import DbConfig from '../../config/DbConfig.js'
import {getLoginId,getLocalConfigList,saveLocalConfig} from '../functions/Common.js'

export default {
	db:null,
	// 开始同步
	start(callback){
		this.init(callback)
	},
	
	// 初始化表和同步数据
	async init(callback){
		if(getLoginId() > 0){
			this.db = DbConfig.connect()
			this.initTable()
			let oldCustomList = await this.getCustomList()
			let customWxidList = await this.asyncCustom(oldCustomList)
			let customList = await this.getCustomList(customWxidList)
			let clusterIds = await this.getClusterList()
			await this.asyncFans(customList)
			await this.asynCluster(customList,clusterIds)
			await this.asyncClusterChatRecord(customList)
			await this.asyncFansTags(customList)
			await this.asyncSysFansTags()
			await this.asyncFansGroup(customList)
			await this.asyncRecently(customList)
			await this.asyncChatRecord(customList)
			await this.upateRecently(customList)
			await this.asyncConfig()
		}
		callback()
	},
	// 创建本地表
	initTable(){
		this.db.transaction(tx=>{
			// 创建客服表
			tx.executeSql('CREATE TABLE IF NOT EXISTS yswl_custom ('+
				'"id" integer NOT NULL,'+
				'"open_id" text,'+
				'"manager_id" integer,'+
				'"wx_name" text,'+
				'"wx_photo" text,'+
				'"is_online" integer,'+
				'"phone_id" text,'+
				'"identity" text,'+
				'"snsId" text,'+
				'"async_fans_id" integer,'+
				'"async_recent_id" integer,'+
				'"async_chat_id" integer,'+
				'"async_cluster_id" integer,'+
				'"async_cluster_chat_id" integer,'+
				'"async_fans_tag_id" integer,'+
				'"is_transfer" integer DEFAULT 0,'+
				'"mark" text,'+
				'PRIMARY KEY ("id"))');

			// 创建粉丝表
			tx.executeSql('CREATE TABLE IF NOT EXISTS yswl_custom_friends ('+
				'"id" integer NOT NULL,'+
				'"custom_id" integer,'+
				'"open_id" text,'+
				'"wx_name" text,'+
				'"wx_photo" text,'+
				'"friend_type" integer,'+
				'"alias" text,'+
				'"con_remark" text,'+
				'"sex" integer,'+
				'"sign" text,'+
				'"fans_type" text,'+
				'"country" text,'+
				'"province" text,'+
				'"city" text,'+
				'"is_comment" integer,'+
				'"is_zan" integer,'+
				'"mobile" text,'+
				'"create_time" text,'+
				'"is_transfer" integer DEFAULT 0,'+
				'PRIMARY KEY ("id"))');

			// 创建最近聊天表
			tx.executeSql('CREATE TABLE IF NOT EXISTS yswl_recently ('+
				'"id" integer NOT NULL,'+
				'"account_open_id" text,'+
				'"friends_open_id" text,'+
				'"friend_or_cluster_id" integer,'+
				'"friend_img" text,'+
				'"friend_name" text,'+
				'"chat_type" integer,'+
				'"last_chat_msg" text,'+
				'"last_chat_msg_type" text,'+
				'"last_modified_time" integer,'+
				'"is_new" integer DEFAULT 0,'+
				'"is_top" integer DEFAULT 0,'+
				'"is_collect" integer DEFAULT 0,'+
				'"no_disturb" integer DEFAULT 0,'+
				'"no_read_num" integer DEFAULT 0,'+
				'"is_transfer" integer DEFAULT 0,'+
				'"is_me" integer DEFAULT 0,'+
				'PRIMARY KEY ("id"))');

			// 创建粉丝聊天记录表
			tx.executeSql('CREATE TABLE IF NOT EXISTS yswl_chat_record ('+
				'"id" integer NOT NULL,'+
				'"custom_id" integer,'+
				'"friend_id" integer,'+
				'"from_id" text,'+
				'"to_id" text,'+
				'"content" text,'+
				'"from_name" text,'+
				'"to_name" text,'+
				'"send_time" text,'+
				'"is_me" integer,'+
				'"is_read" integer,'+
				'"is_send" integer,'+
				'"type" text,'+
				'"msgId" integer,'+
				'"paymsgid" text,'+
				'"transferid" text,'+
				'"msg_params" text,'+
				'"pic_thumb" text,'+
				'"other" text,'+
				'PRIMARY KEY ("id"))');

			// 创建群表
			tx.executeSql('CREATE TABLE IF NOT EXISTS yswl_cluster ('+
				'"id" integer NOT NULL,'+
				'"cluster_name" text,'+
				'"cluster_photo" text,'+
				'"wechat_cluster_id" text,'+
				'"owner_id" integer,'+
				'PRIMARY KEY ("id"))');

			// 创建群成员表
			tx.executeSql('CREATE TABLE IF NOT EXISTS yswl_cluster_member ('+
				'"id" integer NOT NULL,'+
				'"cluster_id" integer NOT NULL,'+
				'"open_id" text,'+
				'PRIMARY KEY ("id"))');

			// 创建群聊天记录表
			tx.executeSql('CREATE TABLE IF NOT EXISTS yswl_cluster_chat_record ('+
				'"id" integer NOT NULL,'+
				'"cluster_id" integer,'+
				'"from_wx_id" text,'+
				'"wechat_cluster_id" text,'+
				'"from_nickname" text,'+
				'"from_photo" text,'+
				'"wechat_cluster_name" text,'+
				'"to_wx_id" text,'+
				'"content" text,'+
				'"send_time" text,'+
				'"is_send" integer,'+
				'"type" text,'+
				'"msgId" text,'+
				'"pic_thumb" text,'+
				'PRIMARY KEY ("id"))');

			// 创建粉丝标签表
			tx.executeSql('CREATE TABLE IF NOT EXISTS yswl_custom_friends_tags ('+
				'"id" integer NOT NULL,'+
				'"custom_id" integer,'+
				'"friend_id" integer,'+
				'"tag_value" text,'+
				'PRIMARY KEY ("id"))');

			// 创建系统粉丝标签自动对应表
			tx.executeSql('CREATE TABLE IF NOT EXISTS yswl_custom_friends_type ('+
				'"fans_type" text,'+
				'"alias" text)');
				
			// 创建粉丝分组表
			tx.executeSql('CREATE TABLE IF NOT EXISTS yswl_friend_group_rel ('+
				'"id" integer NOT NULL,'+
				'"client_type" integer,'+
				'"custom_id" integer,'+
				'"fans_id" integer,'+
				'"chatting_id" integer,'+
				'"group_id" integer,'+
				'PRIMARY KEY ("id"))');
		})
	},
	
	// 获取本地客服列表信息
	getCustomList(customWxidList){
		return new Promise((resolve, reject)=>{
			let sql = "select id,async_fans_id,async_recent_id,async_chat_id,async_cluster_id,async_cluster_chat_id,async_fans_tag_id,open_id from yswl_custom"
			if(customWxidList !== undefined && customWxidList.length>0){
				let customWxids = "";
				for(let i = 0;i<customWxidList.length;i++){
					customWxids += "'"+customWxidList[i]+"',"
				}
				customWxids = customWxids.substr(0,customWxids.length-1);
				sql += " where open_id in ("+customWxids+")"
			}
			this.db.transaction(tx=>{
				tx.executeSql(sql,[],(tx,results)=>{
					let customs = [];
					for (let i = 0; i < results.rows.length; i++){
						customs.push(results.rows[i])
					}
					resolve(customs)
				})
			})
		}).then((data)=>{
			return data
		})
	},
	
	// 获取本地群列表信息
	getClusterList(){
		return new Promise((resolve, reject)=>{
			let clusterIds = []
			this.db.transaction(tx=>{
				tx.executeSql("select id from yswl_cluster",[],(tx,results)=>{
					for (let i = 0; i < results.rows.length; i++){
						clusterIds.push(results.rows[i].id)
					}
					resolve(clusterIds)
				})
			})
		}).then((data)=>{
			return data
		})
	},
	
	// 同步客服
	asyncCustom (oldCustomList){
		return request({
			method: 'post',
			url: 'custom/getList',
			data: {
			  nanagerId: getLoginId()
			}
		}).then(response=>{
			let data = response.data
			let customWxids = []
			if(data.code == 1){
				let customs = data.data
				// 获取客服Id集合
				let customIds = []
				for(let i in customs){
					customIds.push(customs[i].id)
				}
				// 对比客服信息，获取要删除的客服/更新的客服
				let deleteCustomList = []
				let upCustomIds = []
				for(let i in oldCustomList){
					if(customIds.indexOf(oldCustomList[i].id) === -1){
						deleteCustomList.push(oldCustomList[i])
					}else{
						upCustomIds.push(oldCustomList[i].id)
					}
				}
				return new Promise((resolve, reject)=>{
					// 事务处理
					this.db.transaction(tx=>{
						// 删除系统粉丝标签对应关系
						tx.executeSql('delete from yswl_custom_friends_type');
						// 删除所有的转移粉丝数据
						tx.executeSql('delete from yswl_recently where is_transfer = 1');
						// 删除其他数据
						if(deleteCustomList.length > 0){
							let delCustomWxids = "";
							let delCustomIds = "";
							for(let i = 0;i<deleteCustomList.length;i++){
								delCustomWxids += "'"+deleteCustomList[i].open_id+"',";
								delCustomIds += deleteCustomList[i].id+","
							}
							delCustomWxids = delCustomWxids.substr(0,delCustomWxids.length-1);
							delCustomIds = delCustomIds.substr(0,delCustomIds.length-1);
							// 删除聊天记录表
							tx.executeSql("DELETE FROM yswl_chat_record WHERE custom_id in ("+delCustomIds+")");
							// 删除群
							tx.executeSql("DELETE FROM yswl_cluster WHERE id in (SELECT cluster_id from yswl_cluster_member WHERE open_id in ("+delCustomWxids+"))");
							// 删除群成员
							tx.executeSql("delete from yswl_cluster_member where open_id in ("+delCustomWxids+")");
							// 删除客服
							tx.executeSql('delete from yswl_custom where id in ('+delCustomIds+')');
							// 删除粉丝
							tx.executeSql('delete from yswl_custom_friends where custom_id in ('+delCustomIds+')');
							// 删除最近聊天记录表
							tx.executeSql("delete from yswl_recently where account_open_id in ("+delCustomWxids+")");
							// 删除群聊天记录
							tx.executeSql("delete from yswl_cluster_chat_record where to_wx_id in ("+delCustomWxids+")");
							// 删除粉丝标签对应表
							tx.executeSql('delete from yswl_custom_friends_tags where custom_id in ('+delCustomIds+')');
							// 删除粉丝分组表
							tx.executeSql("delete from yswl_friend_group_rel where custom_id in ("+delCustomIds+")");
						}
						// 添加客服信息或更新
						for(let i in customs){
							let custom = customs[i]
							if(upCustomIds.indexOf(custom.id) !== -1){
								tx.executeSql('update yswl_custom set wx_name=?,wx_photo=?,phone_id=?,identity=?,mark=? where id = '+custom.id,
									[custom.wx_name,custom.wx_photo,custom.phone_id,custom.identity,custom.mark])
							}else{
								tx.executeSql('insert into yswl_custom(id,open_id,manager_id,wx_name,wx_photo,is_online,phone_id,identity,snsId,mark,async_fans_id,async_recent_id,async_chat_id,async_cluster_id,async_cluster_chat_id,async_fans_tag_id)'+
									'values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)',
									[custom.id,custom.open_id,custom.manager_id,custom.wx_name,custom.wx_photo,custom.is_online,
										custom.phone_id,custom.identity,custom.snsId,custom.mark,0,0,0,0,0,0])
							}
							customWxids.push(custom.open_id)
						}
						resolve(customWxids)
					})
				})
			}
		}).then((response)=>{
			return response
		})
		.catch((error)=>{
			console.error(error)
			return []
		})
	},
	
	
	// 同步粉丝
	asyncFans(customList) {
		let promise = Promise.resolve(customList);
		if(customList !== undefined && customList.length>0){
			// 循环请求粉丝信息
			for (let i = 0; i< customList.length;i++){
				promise = promise.then((customList)=>{
					return new Promise((resolve, reject)=>{
						request({
							method: 'post',
							url: 'customFans/getList',
							data: {
							  customId:customList[i].id,
							  asyncFansId:customList[i].async_fans_id
							}
						}).then(response=>{
							let fans = response.data.data
							this.db.transaction(tx=>{
								for(let i in fans){
									// 添加数据
									tx.executeSql('insert into yswl_custom_friends(id,custom_id,open_id,wx_name,wx_photo,friend_type,alias,con_remark,sex,sign,fans_type,country,province,city,is_comment,is_zan,mobile,create_time)'+
										'values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)',
										[fans[i].id,fans[i].custom_id,fans[i].open_id,fans[i].wx_name,fans[i].wx_photo,fans[i].friend_type,fans[i].alias,fans[i].con_remark,fans[i].sex,fans[i].sign,fans[i].fans_type,fans[i].country,fans[i].province,fans[i].city,fans[i].is_comment,fans[i].is_zan,fans[i].mobile,fans[i].create_time],
										(tx,results)=>{
											// console.log(results)
										},
										(tx,error)=>{
											// console.log(error)
										})

									// 更新客服信息
									if(i == fans.length - 1){
										tx.executeSql('update yswl_custom set async_fans_id = '+ fans[i].id +' WHERE id = "'+fans[i].custom_id+'"')
									}
								}
								resolve(customList)
							})
						}).catch(e=>{
							// console.error(e)
							resolve(customList)
						})
					})
				})
			}
		} 
		return promise
	},
	
	// 同步最近聊天记录列表
	asyncRecently(customList) {
		let promise = Promise.resolve(customList);
		if(customList !== undefined && customList.length>0){
			// 循环请求数据
			for (let i = 0; i< customList.length;i++){
				promise = promise.then((customList)=>{
					return new Promise((resolve, reject)=>{
						request({
							method: 'post',
							url: 'recently/getList',
							data: {
							  openId:customList[i].open_id,
							  async_recent_id:customList[i].async_recent_id
							}
						}).then(response=>{
							let recently = response.data.data
							this.db.transaction(tx=>{
								for(let i in recently){
									let no_read_num = 0
									if(recently[i].is_new === 1){
										no_read_num = 1
									}
									// 添加数据
									tx.executeSql('insert into yswl_recently(id,account_open_id,friends_open_id,friend_or_cluster_id,friend_img,friend_name,chat_type,last_chat_msg,last_chat_msg_type,last_modified_time,is_new,is_top,is_collect,no_disturb,no_read_num,is_me)'+
										'values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)',
										[recently[i].id,recently[i].account_open_id,recently[i].friends_open_id,recently[i].friend_or_cluster_id,recently[i].friend_img,recently[i].friend_name,recently[i].chat_type,recently[i].last_chat_msg,recently[i].last_chat_msg_type,recently[i].last_modified_time,recently[i].is_new,recently[i].is_top,recently[i].is_collect,recently[i].no_disturb,no_read_num,recently[i].is_me],
										(tx,results)=>{
											// console.log(results)
										},
										(tx,error)=>{
											// console.log(error)
										})

									// 更新客服信息
									if(i == recently.length - 1){
										tx.executeSql('update yswl_custom set async_recent_id = '+ recently[i].id +' WHERE open_id = "'+recently[i].account_open_id+'"')
									}
								}
								resolve(customList)
							})
						}).catch(e=>{
							// console.error(e)
							resolve(customList)
						})
					})
				})
			}
		} 
		return promise
	},
	
	// 同步聊天记录列表
	asyncChatRecord(customList) {
		let promise = Promise.resolve(customList);
		if(customList !== undefined && customList.length>0){
			// 循环请求数据
			for (let i = 0; i< customList.length;i++){
				promise = promise.then((customList)=>{
					return new Promise((resolve, reject)=>{
						request({
							method: 'post',
							url: 'chatRecord/getList',
							data: {
							  customId:customList[i].id,
							  asynChatId:customList[i].async_chat_id
							}
						}).then(response=>{
							let record = response.data.data
							this.db.transaction(tx=>{
								for(let i in record){
									// 添加数据
									tx.executeSql('insert into yswl_chat_record(id,custom_id,friend_id,from_id,to_id,content,from_name,to_name,send_time,is_me,is_read,is_send,type,msgId,paymsgid,transferid,msg_params,pic_thumb,other)'+
										'values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)',
										[record[i].id,record[i].custom_id,record[i].friend_id,record[i].from_id,record[i].to_id,record[i].content,record[i].from_name,record[i].to_name,record[i].send_time,record[i].is_me,record[i].is_read,record[i].is_send,record[i].type,record[i].msgId,record[i].paymsgid,record[i].transferid,record[i].msg_params,record[i].pic_thumb,record[i].other],
										(tx,results)=>{
											// console.log(results)
										},
										(tx,error)=>{
											// console.log(error)
										})

									// 更新客服信息
									if(i == record.length - 1){
										tx.executeSql('update yswl_custom set async_chat_id = '+ record[i].id +' WHERE id = "'+record[i].custom_id+'"')
									}
								}
								resolve(customList)
							})
						}).catch(e=>{
							// console.error(e)
							resolve(customList)
						})
					})
				})
			}
		} 
		return promise
	},
	
	// 同步群列表
	asynCluster(customList,clusterIds) {
		let promise = Promise.resolve(customList);
		if(customList !== undefined && customList.length>0){
			// 循环请求数据
			for (let i = 0; i< customList.length;i++){
				promise = promise.then((customList)=>{
					return new Promise((resolve, reject)=>{
						request({
							method: 'post',
							url: 'cluster/getList',
							data: {
							  openId:customList[i].open_id,
							  asyncClusterId:customList[i].async_cluster_id
							}
						}).then(response=>{
							let clusters = response.data.data
							this.db.transaction(tx=>{
								for(let i in clusters){
									// 添加群数据
									if(clusterIds.indexOf(clusters[i].id) === -1){
										tx.executeSql('insert into yswl_cluster(id,cluster_name,cluster_photo,wechat_cluster_id,owner_id)'+
											'values(?,?,?,?,?)',
											[clusters[i].id,clusters[i].cluster_name,clusters[i].cluster_photo,clusters[i].wechat_cluster_id,clusters[i].owner_id],
											(tx,results)=>{
												// console.log(results)
											},
											(tx,error)=>{
												// console.log(error)
											})
									}
									// 添加成员数据
									tx.executeSql('insert into yswl_cluster_member(id,cluster_id,open_id)'+
										'values(?,?,?)',
										[clusters[i].m_id,clusters[i].id,clusters[i].open_id],
										(tx,results)=>{
											// console.log(results)
										},
										(tx,error)=>{
											// console.log(error)
										})
									// 更新客服信息
									if(i == clusters.length - 1){
										tx.executeSql('update yswl_custom set async_cluster_id = '+ clusters[i].id +' WHERE open_id = "'+clusters[i].open_id+'"')
									}
									clusterIds.push(clusters[i].id)
								}
								resolve(customList)
							})
						}).catch(e=>{
							// console.error(e)
							resolve(customList)
						})
					})
				})
			}
		} 
		return promise
	},
	
	// 同步群聊天记录列表
	asyncClusterChatRecord(customList) {
		let promise = Promise.resolve(customList);
		if(customList !== undefined && customList.length>0){
			// 循环请求数据
			for (let i = 0; i< customList.length;i++){
				promise = promise.then((customList)=>{
					return new Promise((resolve, reject)=>{
						request({
							method: 'post',
							url: 'clusterChatRecord/getList',
							data: {
							  toWxId:customList[i].open_id,
							  asynChatId:customList[i].async_cluster_chat_id
							}
						}).then(response=>{
							let record = response.data.data
							this.db.transaction(tx=>{
								for(let i in record){
									// 添加数据
									tx.executeSql('insert into yswl_cluster_chat_record(id,cluster_id,from_wx_id,wechat_cluster_id,from_nickname,from_photo,wechat_cluster_name,to_wx_id,content,send_time,is_send,type,msgId,pic_thumb)'+
										'values(?,?,?,?,?,?,?,?,?,?,?,?,?,?)',
										[record[i].id,record[i].cluster_id,record[i].from_wx_id,record[i].wechat_cluster_id,record[i].from_nickname,record[i].from_photo,record[i].wechat_cluster_name,record[i].to_wx_id,record[i].content,record[i].send_time,record[i].is_send,record[i].type,record[i].msgId,record[i].pic_thumb],
										(tx,results)=>{
											// console.log(results)
										},
										(tx,error)=>{
											// console.log(error)
										})

									// 更新客服信息
									if(i == record.length - 1){
										tx.executeSql('update yswl_custom set async_cluster_chat_id = '+ record[i].id +' WHERE open_id = "'+record[i].to_wx_id+'"')
									}
								}
								resolve(customList)
							})
						}).catch(e=>{
							// console.error(e)
							resolve(customList)
						})
					})
				})
			}
		} 
		return promise
	},
	
	// 同步粉丝标签
	asyncFansTags(customList) {
		let promise = Promise.resolve(customList);
		if(customList !== undefined && customList.length>0){
			// 循环请求数据
			for (let i = 0; i< customList.length;i++){
				promise = promise.then((customList)=>{
					return new Promise((resolve, reject)=>{
						request({
							method: 'post',
							url: 'customFansTags/getList',
							data: {
							  customId:customList[i].id,
							  asyncFansTagId:customList[i].async_fans_tag_id
							}
						}).then(response=>{
							let tags = response.data.data
							this.db.transaction(tx=>{
								for(let i in tags){
									// 添加数据
									tx.executeSql('insert into yswl_custom_friends_tags(id,custom_id,friend_id,tag_value)'+
										'values(?,?,?,?)',
										[tags[i].id,tags[i].custom_id,tags[i].friend_id,tags[i].tag_value],
										(tx,results)=>{
											// console.log(results)
										},
										(tx,error)=>{
											// console.log(error)
										})

									// 更新客服信息
									if(i == tags.length - 1){
										tx.executeSql('update yswl_custom set async_fans_tag_id = '+ tags[i].id +' WHERE id = "'+tags[i].custom_id+'"')
									}
								}
								resolve(customList)
							})
						}).catch(e=>{
							// console.error(e)
							resolve(customList)
						})
					})
				})
			}
		} 
		return promise
	},
	
	// 同步系统粉丝标签对应表
	asyncSysFansTags() {
		return new Promise((resolve, reject)=>{
			request({
				method: 'post',
				url: 'customFansTags/getSysList',
				data: {
					
				}
			}).then(response=>{
				let data = response.data.data
				this.db.transaction(tx=>{
					// 添加系统标签
					for(let i in data){
						tx.executeSql('insert into yswl_custom_friends_type(fans_type,alias)'+
							'values(?,?)',
							[data[i].fans_type,data[i].alias])
					}
					resolve()
				})
			}).catch(e=>{
				// console.error(e)
				resolve()
			})
		})
	},
	
	// 同步粉丝分组信息
	asyncFansGroup(customList) {
		let promise = Promise.resolve(customList);
		if(customList !== undefined && customList.length>0){
			// 循环请求数据
			for (let i = 0; i< customList.length;i++){
				promise = promise.then((customList)=>{
					return new Promise((resolve, reject)=>{
						request({
							method: 'post',
							url: 'FriendGroupRel/getList',
							data: {
							  customId:customList[i].id,
							  clientType: 1
							}
						}).then(response=>{
							let item = response.data.data
							this.db.transaction(tx=>{
								for(let i in item){
									// 添加数据
									tx.executeSql('insert into yswl_friend_group_rel(id,client_type,custom_id,fans_id,chatting_id,group_id) values(?,?,?,?,?,?)',
										[item[i].id,item[i].client_type,item[i].custom_id,item[i].fans_id,item[i].chatting_id,item[i].group_id],
										(tx,results)=>{
											// console.log(results)
										},
										(tx,error)=>{
											// console.log(error)
										})
								}
								resolve(customList)
							})
						}).catch(e=>{
							// console.error(e)
							resolve(customList)
						})
					})
				})
			}
		} 
		return promise
	},
	
	// 更新最近聊天记录列表
	upateRecently(customList) {
		// 缓存上一次更新的时间
		let cackeKey = 'yswl_sync_time'
		let lastTime =  localStorage.getItem(cackeKey)
		if(lastTime === undefined || lastTime === null){
			lastTime = 0
		}
		localStorage.setItem(cackeKey,new Date().getTime())
		let promise = Promise.resolve(customList);
		if(customList !== undefined && customList.length>0){
			// 循环请求数据
			for (let i = 0; i< customList.length;i++){
				promise = promise.then((customList)=>{
					return new Promise((resolve, reject)=>{
						request({
							method: 'post',
							url: 'recently/getListByTime',
							data: {
							  openId:customList[i].open_id,
							  lastTime:lastTime
							}
						}).then(response=>{
							let recently = response.data.data
							this.db.transaction(tx=>{
								for(let i in recently){
									// 更新数据
									let sql = 'update yswl_recently set last_chat_msg=?,last_chat_msg_type=?,last_modified_time=?,is_top=? where id=?'
									if(recently[i].is_new === 1){
										sql = 'update yswl_recently set last_chat_msg=?,last_chat_msg_type=?,last_modified_time=?,is_top=?,no_read_num=no_read_num+1 where id=?'
									}
									tx.executeSql(sql,[recently[i].last_chat_msg,recently[i].last_chat_msg_type,recently[i].last_modified_time,recently[i].is_top,recently[i].id],
										(tx,results)=>{
											// console.log(results)
										},
										(tx,error)=>{
											// console.log(error)
										})
								}
								resolve(customList)
							})
						}).catch(e=>{
							// console.error(e)
							resolve(customList)
						})
					})
				})
			}
		} 
		return promise
	},
	
	// 保存配置信息
	asyncConfig() {
		return new Promise((resolve, reject)=>{
			request({
				method: 'post',
				url: 'config/getList',
				data: {
					manage_id: getLoginId()
				}
			}).then(response=>{
				let config = getLocalConfigList()
				let data = response.data.data
				if(data != undefined){
					let orderUrl = ''
					let orderPlug = 0
					let lossWeightPlug = 0
					let msgHelperPlug = 0
					let quicklyTechPlug = 0
					let department = ''
					let auto_frieds_no_b_input = 0
					let gamePlug = 0
					let customer_expansion_plug = 0
					let im_show_login_user = 0
					let im_open_organization = 0
					let order2_plug = 0
					let redPacket = 0
					let friend_group = []
					if(data.order_system_url !== undefined && data.order_system_url !== ''){
						orderUrl = data.order_system_url
					}
					if(data.order_plug !== undefined && data.order_plug !== ''){
						orderPlug = data.order_plug
					}
					if(data.loss_weight_plug !== undefined && data.loss_weight_plug !== ''){
						lossWeightPlug = data.loss_weight_plug
					}
					if(data.msg_helper_plug !== undefined && data.msg_helper_plug !== ''){
						msgHelperPlug = data.msg_helper_plug
					}
					if(data.quickly_tech_plug !== undefined && data.quickly_tech_plug !== ''){
						quicklyTechPlug = data.quickly_tech_plug
					}
					if(data.department !== undefined && data.department !== ''){
						department = data.department
					}
					if(data.auto_frieds_no_b_input !== undefined && data.auto_frieds_no_b_input !== ''){
						auto_frieds_no_b_input = data.auto_frieds_no_b_input
					}
					if(data.game_plug !== undefined && data.game_plug !== ''){
						gamePlug = data.game_plug
					}
					if(data.customer_expansion_plug !== undefined && data.customer_expansion_plug !== ''){
						customer_expansion_plug = data.customer_expansion_plug
					}
					if(data.im_show_login_user !== undefined && data.im_show_login_user !== ''){
						im_show_login_user = data.im_show_login_user
					}
					if(data.im_open_organization !== undefined && data.im_open_organization !== ''){
						im_open_organization = data.im_open_organization
					}
					if(data.order2_plug !== undefined && data.order2_plug !== ''){
						order2_plug = data.order2_plug
					}
					if(data.redPacket !== undefined && data.redPacket !== ''){
						redPacket = data.redPacket
					}
					if(data.friend_group !== undefined){
						friend_group = data.friend_group
					}
					config.orderUrl = orderUrl
					config.orderPlug = orderPlug
					config.lossWeightPlug = lossWeightPlug
					config.msgHelperPlug = msgHelperPlug
					config.quicklyTechPlug = quicklyTechPlug
					config.department = department
					config.auto_frieds_no_b_input = auto_frieds_no_b_input
					config.gamePlug = gamePlug
					config.customer_expansion_plug = customer_expansion_plug
					config.im_show_login_user = im_show_login_user
					config.im_open_organization = im_open_organization
					config.order2_plug = order2_plug
					config.redPacket = redPacket
					config.friend_group = JSON.stringify(friend_group)
				
					saveLocalConfig(config)
				}
				resolve(true)
			}).catch(e=>{
				resolve(false)
			})
		})
	}	
}